import { SettingOutlined } from '@ant-design/icons'
import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import { Button, Card, Col, Divider, Flex, Row, Space } from 'antd'
import { Link } from 'react-router-dom'
import Page from '../../../components/Page/Page'
import { Platform } from '../../../components/platform/Platform'
import { useTenant } from '../../../modules/tenant/contexts/tenant/TenantContext'

const PlatformsPage = () => {
  const { platforms, allPlatforms } = useTenant()

  return (
    <Page>
      <Flex vertical gap={0}>
        <PageTitle title="Platforms settings" level={4} style={{ margin: 0 }} />
        <Divider />
        <Row gutter={[32, 32]}>
          <Col span={14} key={'mobile-apps'}>
            <Card
              style={
                platforms['ios']?.identifier === undefined &&
                platforms['android']?.identifier === undefined
                  ? { opacity: 0.4 }
                  : {}
              }
              title={
                <Space>
                  {allPlatforms['ios'].icon}
                  {allPlatforms['android'].icon}
                  Mobile applications
                </Space>
              }
              extra={
                <Link to={`/settings/platforms/mobile-apps`}>
                  <Button
                    type="primary"
                    icon={<SettingOutlined />}
                    disabled={
                      platforms['ios']?.identifier === undefined &&
                      platforms['android']?.identifier === undefined
                    }
                  >
                    Settings
                  </Button>
                </Link>
              }
            >
              <Space size={50}>
                <Platform.Card
                  platform={allPlatforms.ios}
                  identifier={platforms['ios']?.identifier}
                />
                <Platform.Card
                  platform={allPlatforms.android}
                  identifier={platforms['android']?.identifier}
                />
              </Space>
            </Card>
          </Col>
          <Col span={10} key={'whatsapp'}>
            <Card
              style={
                platforms['whatsapp']?.identifier === undefined
                  ? { opacity: 0.4 }
                  : {}
              }
              title={<Space>{allPlatforms['whatsapp'].icon}WhatsApp</Space>}
              extra={
                <Link to={`/settings/platforms/whatsapp`}>
                  <Button
                    type="primary"
                    icon={<SettingOutlined />}
                    disabled={platforms['whatsapp']?.identifier === undefined}
                  >
                    Settings
                  </Button>
                </Link>
              }
            >
              <Platform.Card
                platform={allPlatforms.whatsapp}
                identifier={platforms['whatsapp']?.identifier}
              />
            </Card>
          </Col>
        </Row>
      </Flex>
    </Page>
  )
}

export default PlatformsPage
